import { CmsComponentGroups, IdtComponentCmsDefinition } from 'shared/idt-components/idt-components-cms.model';
import { IdtComponentRole } from 'shared/models/idt-components/idt-component-role.models';
import { IdtComponentDefinition } from 'shared/models/idt-components/idt-component.models';

import { LayoutFragmentsSettings } from './models/layout-fragments.models';


export const LayoutFragmentsDefinition: IdtComponentDefinition = {
  id: 'layout-fragments',
  role: IdtComponentRole.Layout,
  numSlots: 1,
  defaultSlot: 1
};

export const LayoutFragmentsCmsDefinition: IdtComponentCmsDefinition = {
  name: 'Contenido reutilizable',
  group: CmsComponentGroups.Basic,
  availablePlatforms: ['web', 'apps'],
  initialSettings: (): LayoutFragmentsSettings => {
    return {
      general: {},
      styles: {},
      slots: []
    };
  }
};
